
import { sectionConfiguration } from '@app/helpers/models.helpers';
import { lookIn } from '@app/helpers/flipped.helpers';
import { toISO, parseMiddleEndian } from '@app/helpers/date.helpers';
import Vs from '@app/services/validators/validators.service';
// @ts-ignore
import { evolve } from 'ramda';
import { MedicalAppealDetailsComponent } from './medical-appeal-details.component';

const formValidation = (builder: any, recordData: any) => {
  const medicalAppealDetails = lookIn(recordData);
  const houseHoldMember = medicalAppealDetails(['houseHoldMember']);
  const filer = medicalAppealDetails(['filer']);
  const filingDate = parseMiddleEndian(medicalAppealDetails(['filingDate']));
  const appNum = medicalAppealDetails(['appNum']);
  const paidOutOfPocketSw = medicalAppealDetails(['paidOutOfPocketSw']);
  const paidServiceTypeCd = medicalAppealDetails(['paidServiceTypeCd']);
  const paidServiceDtlsTxt = medicalAppealDetails(['paidServiceDtlsTxt']);
  const hasExistingBillsSw = medicalAppealDetails(['hasExistingBillsSw']);
  const billedServiceTypeCd = medicalAppealDetails(['billedServiceTypeCd']);
  const billedServiceDtlsTxt = medicalAppealDetails(['billedServiceDtlsTxt']);
  const deniedRqstdCareSw = medicalAppealDetails(['deniedRqstdCareSw']);
  const alrdyRcvdDeniedCareSw = medicalAppealDetails(['alrdyRcvdDeniedCareSw']);
  const deniedServiceTypeCd = medicalAppealDetails(['deniedServiceTypeCd']);
  const aplDtlsMedDentalTxt = medicalAppealDetails(['aplDtlsMedDentalTxt']);
  const medDeniedAssignedPharmacySw = medicalAppealDetails(['medDeniedAssignedPharmacySw']);
  const pharmacyRequestTypeCd = medicalAppealDetails(['pharmacyRequestTypeCd']);
  const aplDtlsNoLockinRsnTxt = medicalAppealDetails(['aplDtlsNoLockinRsnTxt']);
  const currentPharmacyChngRsnTxt = medicalAppealDetails(['currentPharmacyChngRsnTxt']);
  const rqstdPharmacyTxt = medicalAppealDetails(['rqstdPharmacyTxt']);
  const pharmacyChngRsnTxt = medicalAppealDetails(['pharmacyChngRsnTxt']);
  const currentPharmacyRmvLockinTxt = medicalAppealDetails(['currentPharmacyRmvLockinTxt']);
  const rmvLockinRsnTxt = medicalAppealDetails(['rmvLockinRsnTxt']);
  const missedShiftCareSw = medicalAppealDetails(['missedShiftCareSw']);
  const kindOfInHomeCareCd = medicalAppealDetails(['kindOfInHomeCareCd']);
  const inHomeCareTypeOthTxt = medicalAppealDetails(['inHomeCareTypeOthTxt']);
  const assignedPharmacyRequiredSw = medicalAppealDetails(['assignedPharmacyRequiredSw']);

  const data = builder.group({
    houseHoldMember: [houseHoldMember],
    filer: [filer],
    filingDate: [filingDate],
    appNum: [appNum],
    paidOutOfPocketSw: [paidOutOfPocketSw, Vs.required],
    paidServiceTypeCd: [paidServiceTypeCd],
    paidServiceDtlsTxt: [paidServiceDtlsTxt, Vs.textarea],
    hasExistingBillsSw: [hasExistingBillsSw],
    billedServiceTypeCd: [billedServiceTypeCd],
    billedServiceDtlsTxt: [billedServiceDtlsTxt, Vs.textarea],
    deniedRqstdCareSw: [deniedRqstdCareSw],
    alrdyRcvdDeniedCareSw: [alrdyRcvdDeniedCareSw],
    deniedServiceTypeCd: [deniedServiceTypeCd],
    aplDtlsMedDentalTxt: [aplDtlsMedDentalTxt, Vs.textarea],
    medDeniedAssignedPharmacySw: [medDeniedAssignedPharmacySw],
    pharmacyRequestTypeCd: [pharmacyRequestTypeCd],
    aplDtlsNoLockinRsnTxt: [aplDtlsNoLockinRsnTxt, Vs.textarea],
    currentPharmacyChngRsnTxt: [currentPharmacyChngRsnTxt, Vs.textarea],
    rqstdPharmacyTxt: [rqstdPharmacyTxt, Vs.textarea],
    pharmacyChngRsnTxt: [pharmacyChngRsnTxt, Vs.textarea],
    currentPharmacyRmvLockinTxt: [currentPharmacyRmvLockinTxt, Vs.textarea],
    rmvLockinRsnTxt: [rmvLockinRsnTxt, Vs.textarea],
    missedShiftCareSw: [missedShiftCareSw],
    kindOfInHomeCareCd: [Array.isArray(kindOfInHomeCareCd) ? kindOfInHomeCareCd : []],
    inHomeCareTypeOthTxt: [inHomeCareTypeOthTxt, Vs.textarea],
    assignedPharmacyRequiredSw: [assignedPharmacyRequiredSw],
  });

  return { data };
};

const postObject = evolve({
  filingDate: toISO
});

export default sectionConfiguration(MedicalAppealDetailsComponent, formValidation, ['YESNO', 'CARERECEIVED', 'PHARMACYCHANGE', 'KINDOFINHOMECARE'], [], {}, {
  postObject,
  hasSummary: false,
  showSubmit: false,
  showComments: false,
  showSaveAndExit: false,
});